import { render, staticRenderFns } from "./viewInventory.vue?vue&type=template&id=eb4855d8&scoped=true&"
import script from "./viewInventory.vue?vue&type=script&lang=js&"
export * from "./viewInventory.vue?vue&type=script&lang=js&"
import style0 from "./viewInventory.vue?vue&type=style&index=0&id=eb4855d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4855d8",
  null
  
)

export default component.exports